<template>
  <v-pagination
    v-show="pages > 1"
    v-model="curPage"
    :length="pagination.pages"
    prev-icon="mdi-arrow-left"
    next-icon="mdi-arrow-right">
  </v-pagination>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import events from 'Store/events'

export default {
  name: 'queues-list-pagination',
  computed: {
    ...mapGetters({ pagination: 'queues/pagination' }),
    pages: function () {
      return this.pagination.pages
    },
    curPage: {
      get: function () {
        return this.pagination.curPage
      },
      set: function (page) {
        this.$emit('loading')
        this.pageLoad(page).catch(err => {
          events.pubError(`Failed to load queues page: ${err.type} (${err.exception})`)
          this.dbg(err)
        }).finally(() => {
          this.$emit('loading')
        })
      }
    }
  },
  methods: mapActions({ pageLoad: 'queues/pageLoad' })
}
</script>

<style scoped>
</style>
